import React, { useEffect, useState } from 'react';
import { Table, Button, Checkbox, Space, InputNumber, notification } from 'antd';
import { SendOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';
import Layout from '../components/layout';
import { addUserProducts, getProduct } from '../services/authService';
import { jwtDecode } from "jwt-decode";


const UserProductSelectionPage = ({}) => {
  const [selectedProducts, setSelectedProducts] = useState({});
  const [products, setProducts] = useState([])
  // Columns for the product table
  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Select',
      key: 'select',
      render: (text, record) => (
        <Checkbox
          checked={!!selectedProducts[record.id]}
          onChange={() => handleProductSelect(record.id)}
        />
      ),
    },
    {
      title: 'Quantity',
      key: 'quantity',
      render: (text, record) => (
        <Space>
          <Button
            icon={<MinusOutlined />}
            onClick={() => updateQuantity(record.id, selectedProducts[record.id]?.quantity - 1)}
            disabled={!selectedProducts[record.id] || selectedProducts[record.id].quantity <= 1}
          />
          <InputNumber
            min={1}
            value={selectedProducts[record.id]?.quantity || 1}
            onChange={(value) => updateQuantity(record.id, value)}
            disabled={!selectedProducts[record.id]}
          />
          <Button
            icon={<PlusOutlined />}
            onClick={() => updateQuantity(record.id, selectedProducts[record.id]?.quantity + 1)}
            disabled={!selectedProducts[record.id]}
          />
        </Space>
      ),
    },
  ];

  const fetchProducts = async () => {
    const allProducts = await getProduct();
    setProducts(allProducts);
  };
  useEffect(() => {
    fetchProducts();
  }, []);

  // Handle checkbox selection
  const handleProductSelect = (id) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected[id]) {
        const updated = { ...prevSelected };
        delete updated[id];
        return updated;
      } else {
        return { ...prevSelected, [id]: { quantity: 1 } };
      }
    });
  };

  // Update quantity of selected products
  const updateQuantity = (id, quantity) => {
    if (quantity > 0) {
      setSelectedProducts((prevSelected) => ({
        ...prevSelected,
        [id]: { ...prevSelected[id], quantity },
      }));
    }
  };

  const handleSubmit = async () => {
    const selectedProductEntries = Object.entries(selectedProducts);
    if (selectedProductEntries.length === 0) {
      notification.error({ message: 'Please select at least one product!' });
      return;
    }
  
    // Decode JWT token to get user ID
    const token = localStorage.getItem("userToken");
    if (!token) {
      notification.error({ message: 'User not authenticated. Please log in.' });
      return;
    }
  
    const decodedToken = jwtDecode(token);
    console.log("userToken" , decodedToken)

    const userId = decodedToken?.id;
    if (!userId) {
      notification.error({ message: 'Invalid token. Could not retrieve user ID.' });
      return;
    }
  
    // Map selected products to the format expected by the backend
    const selectedDetails = selectedProductEntries.map(([id, { quantity }]) => ({
      productId: id,
      quantity,
    }));
  
    // Define payload with userId
    const payload = {
      userId,
      products: selectedDetails,
    };
  
    // Send request to backend to add products
    try {
      const response = await addUserProducts(payload); // Call to backend service
      notification.success({
        message: 'Product Submission Successful',
        description: 'Your product selection has been saved.',
      });
    } catch (error) {
      notification.error({
        message: 'Error Saving Products',
        description: 'There was an issue with saving your product selection.',
      });
    }
  };

  // Mock email sending function (Replace with your backend API)
  const sendEmail = async (selectedDetails) => {
    try {
      // Here, you can call your backend API to send the email
      return { success: true };
    } catch (error) {
      console.error('Error sending email:', error);
      return { success: false };
    }
  };

  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <h2>Select Products</h2>
        <Table
          columns={columns}
          dataSource={products}
          rowKey="id"
          pagination={false}
          bordered
        />
        <Space style={{ marginTop: '20px' }}>
          <Button
            type="primary"
            icon={<SendOutlined />}
            onClick={handleSubmit}
          >
            Submit Selection
          </Button>
        </Space>
      </div>
    </Layout>
  );
};

export default UserProductSelectionPage;
